import $ from 'jquery';

import BaseController from 'chairisher/_controller';
import FacebookAnalytics from 'chairisher/analytics/facebook';

import {
    AmplitudeEventProperty,
    TrackingScreen,
    TradePosition,
    logAmplitudeButtonClickEvent,
    logScreenView,
} from 'chairisher/util/analytics';

/**
 * Controller that binds actions for the trade confirmation page
 */
class TradeInformationController extends BaseController {
    bindPageAnalytics() {
        super.bindPageAnalytics();

        logScreenView(TrackingScreen.TRADE_INFORMATION);

        $('.js-trade-signup-btn-bottom, .js-trade-signup-btn-top').on('click', ({ currentTarget }) => {
            const $btn = $(currentTarget);

            logAmplitudeButtonClickEvent($btn.text().toLowerCase().trim(), {
                [AmplitudeEventProperty.CTA_POSITION]: $btn.hasClass('js-trade-signup-btn-top')
                    ? TradePosition.SIGNUP_TOP
                    : TradePosition.SIGNUP_BOTTOM,
            });

            FacebookAnalytics.logFacebookEvent(['trackCustom', 'TradeCompleteRegistration']);
        });
    }
}

export default TradeInformationController;
